export const DIALOG_READ_REQUEST = "DIALOG_READ_REQUEST";
export const DIALOG_READ = "DIALOG_READ";
export const MESSAGE_CREATE = "MESSAGE_CREATE";
export const MESSAGE_CREATE_REQUEST = "MESSAGE_CREATE_REQUEST";
export const MESSAGE_UPDATE = "MESSAGE_UPDATE";
